import React from "react";
import { MapPin } from "lucide-react";

export const validCoords = (lat, lng) => Number.isFinite(lat) && Number.isFinite(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;

// A live share is "live" only while not revoked and not expired; otherwise it's shown as ended.
const liveState = (l) => {
  if (!l.session_id) return null;
  if (l.revoked || (l.expires_at && new Date(l.expires_at) < new Date())) return "ended";
  return "live";
};

export function LocationBubble({ m, mine, when }) {
  const { lat, lng } = m.location;
  const live = liveState(m.location);
  const manual = m.location.source === "manual";
  return (
    <a href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`} target="_blank" rel="noopener noreferrer"
       className={`max-w-[80%] w-64 rounded-2xl overflow-hidden border ${mine ? "bg-[#E05E36] border-[#E05E36] text-white" : "bg-white border-stone-200 text-stone-800"}`}
       data-testid="chat-location-bubble" data-lat={lat} data-lng={lng}>
      <div className="relative w-full h-32 bg-gradient-to-br from-emerald-50 to-sky-100">
        <iframe title={`Location ${lat},${lng}`} loading="lazy" className="w-full h-full border-0 pointer-events-none"
                src={`https://www.openstreetmap.org/export/embed.html?bbox=${lng - 0.005}%2C${lat - 0.003}%2C${lng + 0.005}%2C${lat + 0.003}&layer=mapnik&marker=${lat}%2C${lng}`} />
      </div>
      <div className="px-3 py-2 text-sm font-semibold flex items-center gap-1">
        <MapPin size={14} /> <span className="truncate">{m.location.label || (manual ? "Pinned on map" : "Shared location")}</span>
        {live && (
          <span className={`ml-auto shrink-0 text-[10px] font-black uppercase tracking-widest px-1.5 py-0.5 rounded-full ${live === "live" ? (mine ? "bg-white/20" : "bg-emerald-100 text-emerald-800") : "bg-stone-200 text-stone-600"}`}
                data-testid="chat-location-live">{live === "live" ? "LIVE" : "Live ended"}</span>
        )}
      </div>
      <div className={`px-3 pb-2 text-[10px] ${mine ? "text-white/70" : "text-stone-400"}`} data-testid="chat-location-meta">
        {manual ? "Chosen on map" : "Device location"}{m.location.accuracy_m ? ` · ±${Math.round(m.location.accuracy_m)} m` : ""} · {lat.toFixed(5)}, {lng.toFixed(5)} · {when} · Tap to open in Maps
      </div>
    </a>
  );
}
